import { useT } from '../lib/i18n'

/** FR-12: Vorschlags-Chips unter jeder Antwort. */
export function SuggestionChips({
  suggestions,
  onPick,
}: {
  suggestions: string[]
  onPick: (text: string) => void
}) {
  const t = useT()
  if (suggestions.length === 0) return null
  return (
    <div
      className="-mx-4 flex gap-2 overflow-x-auto px-4 pb-1 [scrollbar-width:none]"
      role="group"
      aria-label={t.suggestionsLabel}
    >
      {suggestions.map((s) => (
        <button
          key={s}
          onClick={() => onPick(s)}
          className="shrink-0 rounded-full bg-surface px-4 py-2 text-sm text-text shadow-[var(--shadow-card)] transition-colors hover:bg-surface-2"
        >
          {s}
        </button>
      ))}
    </div>
  )
}
